import { track } from "@amplitude/analytics-react-native";
import { amp } from "src/api/amplitude";
import { useGatheringContext } from "src/contexts/GatheringContext";
import useStabilizedCallback from "src/hooks/useStabilizedCallback";
import { useModal } from "src/modals";
import GatheringModal from "src/modals/configs/GatheringModal";

const usePresentPhoto = () => {
	const context = useGatheringContext();
	const { presentModal } = useModal<GatheringModal>();

	const presentPhoto = useStabilizedCallback(
		({ photoId }: { photoId: string }) => {
			track(amp.gathering.photoExpand, {
				photoId,
			});
			presentModal("PhotoDetailModal", {
				props: {
					context,
					initialPhotoId: photoId,
				},
				closeOnHookUnmount: false,
			});
		},
		[context, presentModal],
	);
	return presentPhoto;
};
export default usePresentPhoto;
